module.exports = __webpack_public_path__ + "static/media/estrela_dourada_meia.e155f755.svg";